import axiosInstance, { axiosAlertInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { TARGETED_RECONCILIATION_API_URL_CONFIG } from './constants';
import {
  ITargetedReconciliationFilters,
  ITargetedReconciliationResponse,
} from './types';

export const fetchAllTargetedReconciliation = (
  filters: ITargetedReconciliationFilters,
): Promise<AxiosResponse<ITargetedReconciliationResponse, any>> => {
  return axiosInstance({
    url: TARGETED_RECONCILIATION_API_URL_CONFIG.GET_ALL,
    params: {
      ...(filters.providerId ? { providerId: filters.providerId } : {}),
      ...(filters.status ? { status: filters.status } : {}),
      ...(filters.vdiTransactionId
        ? { vdiTransactionId: filters.vdiTransactionId }
        : {}),
      ...(filters.operatorId ? { operatorId: filters.operatorId } : {}),
      ...(filters.startDtm ? { startDtm: filters.startDtm } : {}),
      ...(filters.endDtm ? { endDtm: filters.endDtm } : {}),
      ...(filters.order ? { order: filters.order } : {}),
      ...(filters.orderby ? { orderby: filters.orderby } : {}),
      ...(filters.reconcileId ? { reconcileId: filters.reconcileId } : {}),
      ...(filters.page ? { page: filters.page } : {}),
      ...(filters.limit ? { limit: filters.limit } : {}),
    },
  });
};
